import { render, staticRenderFns } from "./Moxingdaima.vue?vue&type=template&id=8c5bd900&scoped=true&"
import script from "./Moxingdaima.vue?vue&type=script&lang=js&"
export * from "./Moxingdaima.vue?vue&type=script&lang=js&"
import style0 from "./Moxingdaima.vue?vue&type=style&index=0&id=8c5bd900&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5bd900",
  null
  
)

export default component.exports